(function () {
    "use strict";

    // @ngInject
    function OnBoardingMobileGuideControllerCtor($scope, $injector, $timeout,
                                                 moment, _, OnboardingService, EventService, UsersManager, AnalyticsService, $translate, UserService, $state, UiPersistenceService, $stateParams) {

        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'OnBoardingMobileGuideController';

        this._ = _;
        this.UserService = UserService;
        this.UsersManager = UsersManager;
        this.$state = $state;
        this.OnboardingService = OnboardingService;
        this.EventService = EventService;
        this.AnalyticsService = AnalyticsService;

        this.$stateParams = $stateParams;

        this.UiPersistenceService = UiPersistenceService;
        this.$translate = $translate;

        this.panelSteps =
            [
                'COME_AS_YOU_ARE',
                'CONQUER_THE_CHAOS',
                'ULTIMATE_CLIENT_EXPERIENCE',
                'SET_UP_FAST',
                'FINISH_ACCOUNT_SETUP'
    ];

        this.currentPanelsOrder = [0, 1, 2, 3, 4];

        if ($stateParams.step) {
            this.currentStepIndex = parseInt($stateParams.step);
        }
        else {
            this.currentStepIndex = 0;
        }

        this.currentStep = this.panelSteps[this.currentStepIndex];

        this.isLoading = false;

        this.initialOnboardingStep(this.currentStepIndex);

    }

    Controllers.OnBoardingMobileGuideController = Class(Controllers.BaseController, {
        constructor: OnBoardingMobileGuideControllerCtor,

        initialOnboardingStep: function initialOnboardingStep(stepIndex) {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.onboarding_mobile_guide_load_panel, {
                initial_step: this.panelSteps[stepIndex]
            });
        },

        jumpOnboardingStep: function jumpOnboardingStep(indexInOrder) {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.onboarding_mobile_guide_click_panel_jump,
                {
                    origin_panel_id: this.currentStepIndex + 1,
                    panel_destination: this.panelSteps[this.currentPanelsOrder[indexInOrder]] // according to the variant.
                }
            );
            this.setOnboardingStep(this.currentPanelsOrder[indexInOrder]);

            // account setup.
            if (this.currentStepIndex === 4) {
                this.OnboardingService.sendTrialerOfferAccountSetup();
            }
        },

        setOnboardingStep: function setOnboardingStep(destination) {
            this.currentStepIndex = destination;
            this.currentStep = this.panelSteps[this.currentStepIndex];

            this.$state.go(this.AppStates.root_core_onboardingMobileGuideStep, {step: this.currentStepIndex}, {notify: false});
        },

        nextOnboardingStep: function nextOnboardingStep(swiped) {
            var swiped = swiped || false;
            var lastPanelIndex = this.currentPanelsOrder[this.currentPanelsOrder.length - 1];

            // account setup.
            if (this.currentStepIndex === 3) {
                this.OnboardingService.sendTrialerOfferAccountSetup();
            }

            if (this.currentStepIndex != lastPanelIndex) {
                if (!swiped) {
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.onboarding_mobile_guide_click_panel_next,
                        {
                            origin_panel_id: this.currentStepIndex + 1,
                            origin_panel_name: this.currentStep
                        }
                    );
                }
                this.currentStepIndex = this.currentPanelsOrder[this.currentPanelsOrder.indexOf(this.currentStepIndex) + 1]; // get next according to variant.
                this.setOnboardingStep(this.currentStepIndex);

            } else {
                this.OnboardingService.skipPreAppOnboarding();
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.onboarding_mobile_guide_click_panel_finish_account_setup);
                this.$state.go(this.AppStates.root_core_navigation_onboardingSetupGuide);
            }
        },

        previousOnboardingStep: function previousOnboardingStep() {
            if (this.currentStepIndex > 0) {
                // get next according to variant.
                this.currentStepIndex = this.currentPanelsOrder[this.currentPanelsOrder.indexOf(this.currentStepIndex) - 1];
                this.setOnboardingStep(this.currentStepIndex);

                // account setup.
                if (this.currentStepIndex === 4) {
                    this.OnboardingService.sendTrialerOfferAccountSetup();
                }
            }
        },

        //--------------------------------------------------------------------------------------------------

        //Was relevant for variant C with 4 options. not deleting code because it could be useful for other onboarding flows.
        goToCreateInvoice: function goToCreateInvoice() {
            this.UsersManager.createFirstInvoice('first Invoice', '0', 'first Invoice').then(function (success) {
                if (success.data && success.data._id) {
                    this.OnboardingService.skipPreAppOnboarding();
                    this.$state.go(this.AppStates.root_core_workspaceFile, {workspace_file_id: success.data._id});
                }
            }.bind(this));

        },
        //Was relevant for variant C with 4 options. not deleting code because it could be useful for other onboarding flows.
        goToBrandSetup: function goToBrandSetup() {
            //complete the pre app onboarding
            this.OnboardingService.skipPreAppOnboarding();

            this.$state.go(this.AppStates.root_core_navigation_settings_company_branding);
        },

        //Was relevant for variant C with 4 options. not deleting code because it could be useful for other onboarding flows.
        goToExampleProposal: function goToExampleProposal() {
            this.isLoading = true;
            this.UserService.createExampleProposal().finally(function () {
                this.UiPersistenceService.setUiPersistence(
                    this.UiPersistenceService.keys.showExampleProposal, {dontShow: true});
                this.OnboardingService.markOnboardingOverviewTasksComplete('clientSideClicked');
                this.OnboardingService.skipPreAppOnboarding();
                this.isLoading = false;
            }.bind(this));
        },

        //Was relevant for variant C with 4 options. not deleting code because it could be useful for other onboarding flows.
        goToPipeline: function goToPipeline() {
            this.OnboardingService.skipPreAppOnboarding();
            this.$state.go(this.AppStates.root_core_navigation_pipeline);
        },

        getSubtitle: function getSubtitle() {
            return "ONBOARDING.MOBILE_GUIDE.ACCOUNT_SETUP." + this.currentStep + "._SUBTITLE_";
        },

        hasSubtitle: function hasSubtitle() {
            return Boolean(this.$translate.instant(this.getSubtitle()).length);
        },

        isCurrentStep: function isCurrentStep(step) {
            return this.currentStep === this.panelSteps[step];
        },

        handleSwipeLeft: function handleSwipeLeft() {
            var lastPanelIndex = this.currentPanelsOrder[this.currentPanelsOrder.length - 1];

            if (this.currentStepIndex < lastPanelIndex) {
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.onboarding_mobile_guide_swipe_panel_next);
                this.nextOnboardingStep(true);
            }
        },

        handleSwipeRight: function handleSwipeRight() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.onboarding_mobile_guide_swipe_panel_previous);
            this.previousOnboardingStep();
        },
    });
}());
